<template>
  <div class="width-percent-100 flex-between">
    <div class="card-list__box">
      <div class="flex-start-between width-percent-100">
        <div class="card-list__image-box flex-start-between">
          <span
            class="position-relative"
            @click.stop="toggleProfilePopup(item)"
            v-click-outside="closeProfilePopup"
          >
            <b-img-lazy
              class="card-list__image"
              :src="pathOr('', ['image_address'], item)"
              :onerror="`this.src='${defaultImage}';this.classList.add('padding-13')`"
            />
            <ProfileBoxPopup
              :show="profilePopupId === item.code"
              :userData="parvandehSelectedData"
              primaryKey="personCode"
              :extraPersonParams="{ parvandehCode: item.code }"
              :showChangeInfo="false"
              :showLogout="false"
              :hasVersion="false"
              :duration="100"
              transitionName="slide-y-up-transition"
              deskTopPopupClass="top-304"
              profileModalClass="bottom-0"
              @setShow="closeProfilePopup"
            />
          </span>
          <div class="width-max-content padding-left-16">
            <div class="card-list__title">
              <span
                class="card-list__name"
                @click.stop="toggleProfilePopup(item)"
              >
                {{ generateFullName(item) }}
              </span>
              |
              <CopyTextWrapper
                :id="item.code"
                :text="item.parvandeh_number"
                textClass="card-list__parvandeh-number"
              />

              <div class="card-list__caption">
                {{ pathOr("", ["term", "caption"], item) }}
              </div>
            </div>
          </div>
        </div>
        <MenuPopupWrapper
          v-if="checkScreenDevice(['mobile'])"
          class="tablet-none desktop-none"
          iconClass="card-list__more-icon"
          menuClass="left-0 top-0 z-index-1 padding-top-24"
          :items="itemButtons"
          :permissions="permissions"
          :showMenu="itemMenuId === item.code"
          :rowItem="item"
          :hasEventCapturing="false"
          @click="showItemMenu"
          @close="closeItemMenu"
        />
      </div>
      <div class="tablet-none desktop-none flex-start width-percent-100">
        <PieChart
          :percent="calcPercentage(+item.total_item, +item.incomplete_item)"
          barColor="#0085FF"
          trackColor="#E0F0FF"
        />
        <span class="font-size-12 color-complementary-400 margin-right-12">
          {{ $lang.completed }}
        </span>
      </div>
    </div>
    <div class="card-list__box mobile-none">
      <PieChart
        :percent="calcPercentage(+item.total_item, +item.incomplete_item)"
        barColor="#0085FF"
        trackColor="#E0F0FF"
        v-b-tooltip.hover
        :title="`${calcPercentage(+item.total_item, +item.incomplete_item)}% ${
          $lang.completed
        }`"
      />
    </div>
    <div class="card-list__box position-relative mobile-none">
      <span></span>
      <MenuPopupWrapper
        v-if="checkScreenDevice(['tablet', 'desktop'])"
        iconClass="card-list__more-icon"
        menuClass="left-0 top-10 z-index-1 padding-top-24"
        :items="itemButtons"
        :permissions="permissions"
        :showMenu="itemMenuId === item.code"
        :rowItem="item"
        :hasEventCapturing="false"
        @click="showItemMenu"
        @close="closeItemMenu"
      />
    </div>
  </div>
</template>

<script>
import {
  MenuPopupWrapper,
  PieChart,
  ProfileBoxPopup,
  CopyTextWrapper,
} from "@/components/re-design";
import {
  calcPercentage,
  checkScreenDevice,
  generateConfig,
  generateLang,
} from "@/shared/utils";
import { pathOr } from "ramda";
import { computed, ref, toRefs } from "vue";
export default {
  components: { MenuPopupWrapper, PieChart, ProfileBoxPopup, CopyTextWrapper },
  props: {
    item: {
      type: Object,
      default: null,
    },
    permissions: {
      type: Array,
      default: () => [],
    },
    itemButtons: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    // bind props
    const { item } = toRefs(props);

    const defaultImage = generateConfig([
      "images",
      "shared",
      "redesign",
      "empty",
      "noUser",
    ]);

    const parvandehSelectedData = computed(() => {
      const code = pathOr("", ["code"], item.value);
      const personCode = pathOr("", ["person", "code"], item.value);
      const avatar = pathOr("", ["image_address"], item.value);
      const name = pathOr("", ["person", "name"], item.value);
      const family = pathOr("", ["person", "family"], item.value);
      const fullName = `${name} ${family}`;
      const mobile = pathOr("", ["person", "mobile"], item.value);

      return {
        avatar,
        fullName,
        mobile,
        personCode,
        code,
      };
    });

    const generateFullName = () => {
      const name = pathOr("", ["person", "name"], item.value);
      const family = pathOr("", ["person", "family"], item.value);
      return `${name} ${family}`;
    };

    const parvandehSelected = ref(null);
    const profilePopupId = ref(null);
    const toggleProfilePopup = () => {
      parvandehSelected.value = item.value;
      const code = pathOr("", ["code"], item.value);
      profilePopupId.value = profilePopupId.value === code ? null : code;
    };
    const closeProfilePopup = () => {
      profilePopupId.value = null;
    };

    const itemMenuId = ref(null);
    const showItemMenu = (item) => {
      const code = pathOr("", ["code"], item);
      itemMenuId.value = itemMenuId.value === code ? null : code;
    };
    const closeItemMenu = () => {
      itemMenuId.value = null;
    };

    // return data to be used in template
    return {
      defaultImage,
      calcPercentage,
      toggleProfilePopup,
      parvandehSelected,
      profilePopupId,
      closeProfilePopup,
      itemMenuId,
      showItemMenu,
      closeItemMenu,
      generateFullName,
      pathOr,
      parvandehSelectedData,
      checkScreenDevice,
    };
  },
};
</script>
